import { sortLayersByOrder } from "../../configuration/utils.js"

const rapid120180 = (values, currentArea) => {
  const layers = []

  if(currentArea === "POTENCIA_SECCION"){
    layers.push({ folder: "POTENCIA", imageName: "FONDO" })
    layers.push({ folder: "POTENCIA", imageName: values.EV_POTENCIA })
  }else{
    // BODY
    layers.push({ folder: "BODY", imageName: values.EV_NUM_CONECTORES })

    let longitudOrSystem = '';
    if(!values.EV_LONGITUD_MANGUERA || values.EV_LONGITUD_MANGUERA === ""){
      longitudOrSystem = values.EV_GESTION_MANGUERA
    }else{
      longitudOrSystem = values.EV_LONGITUD_MANGUERA
    }
    // LEFT FRONT
    if (values.EV_TIPO_CONECTOR_LEFT_FRONT) {
      layers.push({
        folder: "LEFT_FRONT",
        imageName:
          longitudOrSystem + "_" + values.EV_TIPO_CONECTOR_LEFT_FRONT,
      })
    }

    // RIGHT FRONT
    if (values.EV_TIPO_CONECTOR_RIGHT_FRONT) {
      layers.push({
        folder: "RIGHT_FRONT",
        imageName:
          longitudOrSystem + "_" + values.EV_TIPO_CONECTOR_RIGHT_FRONT,
      })
    }

    // OTHERS
    if (values.EV_CONTACTLESS) {
      layers.push({
        folder: "OTHERS",
        imageName: "CONTACTLESS",
      })
    }

    if (values.EV_PULSADOR_EMERGENCIA === true) {
      layers.push({
        folder: "OTHERS",
        imageName: "PULSADOR_EMERGENCIA",
      })
    }

    if (values.EV_NUM_CONECTORES.endsWith("_TRIO")) {
      if (values.EV_GESTION_MANGUERA === "BRAZOS") {
        layers.push({ folder: "OTHERS", imageName: "AC" })
      }

      const index = layers.findIndex(
        layer => layer.folder === "LEFT_SIDE" && layer.imageName === "AC_22"
      )
      if (index !== -1) layers.splice(index, 1)
    }

    if (values.EV_PANTALLA) {
      layers.push({
        folder: "OTHERS",
        imageName: "PANTALLA",
      })
    }

    if (values.EV_MOBILE) {
      layers.push({ folder: "OTHERS", imageName: "MOBILE" })
    }
  }

  // ORDEN PERSONALIZADO
  const layerOrder = [
    "BODY",
    "OTHERS:PULSADOR_EMERGENCIA",
    "RIGHT_FRONT",
    "OTHERS:CONTACTLESS",
    "RIGHT_SIDE",
    "OTHERS:PANTALLA",
    "LEFT_FRONT",
    "LEFT_SIDE",
    "OTHERS:AC",
    "OTHERS:MOBILE",
  ]

  return sortLayersByOrder(layers, layerOrder)
}

export default rapid120180
